import React from 'react'
import { IconButton } from '@mui/material'
import { EditRounded } from '@mui/icons-material'
import { COLOR } from '../../../utils/constants/color.constants'

const UIIconButtonEdit = ({ sx, ...props }) => {
  return (
    <IconButton
      sx={{
        borderRadius: '6px',
        '&:hover': {
          '& svg': {
            fill: COLOR.ORANGE,
          },
        },
        ...sx,
      }}
      {...props}
    >
      <EditRounded sx={{ fill: COLOR.GRAY_MEDIUM }} />
    </IconButton>
  )
}

export default UIIconButtonEdit
